import React from 'react'

import { useChat } from '../../chat-context'
import MenuItem from '~components/shared/menu/menu-item'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5'

export default function ShowErrorMessagesCheckbox() {
    const { showErrors, setShowErrors } = useChat()

    return (
        <MenuItem
            icon={showErrors ? IoCheckbox : IoSquareOutline}
            onClick={() => {
                setShowErrors(!showErrors)
            }}
            iconProps={{
                color: showErrors ? 'brand.500' : 'gray.400',
            }}
        >
            Show Error Messages?
        </MenuItem>
    )
}
